export default function BlogSection() {
  const tips = [
    {
      icon: 'ri-palette-line',
      title: 'Como Escolher Sua Cor',
      description: 'Dicas para combinar seu Crocs personalizado com seu estilo pessoal e guarda-roupa favorito.',
      color: 'from-orange-500 to-pink-500'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Cuidados com os Pins',
      description: 'Aprenda a manter seus pins decorativos sempre bonitos e bem fixados no seu Crocs.',
      color: 'from-pink-500 to-yellow-500'
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Looks Divertidos',
      description: 'Inspire-se com combinações criativas usando Crocs coloridos para diferentes ocasiões.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: 'ri-heart-line',
      title: 'Conforto o Dia Todo',
      description: 'Por que Crocs são perfeitos para uso diário: leveza, durabilidade e estilo único.',
      color: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm text-orange-600 font-semibold mb-2">• Dicas e Inspiração</p>
          <h2 className="text-6xl font-bold text-gray-900 mb-4">Guia de Estilo Crocs</h2>
          <p className="text-xl text-gray-600">Aproveite ao máximo seu Crocs personalizado</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${tip.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${tip.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{tip.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{tip.description}</p>
              <button
                onClick={() => window.open('https://wa.me/258869689262?text=Olá! Gostaria de saber mais sobre ' + tip.title, '_blank')}
                className="text-orange-600 font-semibold hover:text-orange-700 transition-colors flex items-center gap-2 cursor-pointer"
              >
                Saber Mais
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Tem dúvidas sobre nossos Crocs personalizados?
          </p>
          <button
            onClick={() => window.open('https://wa.me/258869689262?text=Olá! Tenho algumas dúvidas sobre os Crocs.', '_blank')}
            className="inline-flex items-center gap-3 px-10 py-5 bg-green-500 text-white text-lg font-semibold rounded-full hover:bg-green-600 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-whatsapp-line text-2xl"></i>
            </div>
            Fale Conosco no WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
}
